"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WolfMTADeclineTextOutputWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@athena-portal/core");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var WolfMotorMTADeclineText_1 = require("../../declineTextOutputWidget/WolfMotorMTADeclineText");
var react_router_dom_1 = require("react-router-dom");
var commonFunctions_1 = require("../../../commonFunctions");
var WolfMTADeclineTextOutputWidget = /** @class */ (function (_super) {
    __extends(WolfMTADeclineTextOutputWidget, _super);
    function WolfMTADeclineTextOutputWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.underwritingResultArray = _this.props.engine.getInteraction().underwritingResult;
        _this.generateText = function () {
            _this.setState({ declineMessage: _this.renderWording(_this.underwritingResultArray[0].objectName) });
        };
        _this.renderWording = function (underwritingRule) {
            var declineText = new WolfMotorMTADeclineText_1.WolfMotorMTADeclineText(_this.props);
            var journeyState = _this.props.engine.getJourneyState();
            var mtaHardDecline = journeyState.mtaHardDecline;
            for (var _i = 0, _a = declineText.underwritingResultCustomerWordings; _i < _a.length; _i++) {
                var uw = _a[_i];
                if (uw.key === underwritingRule) {
                    var hardDecline = uw.declineType === "hard";
                    if (mtaHardDecline && hardDecline) {
                        _this.setHardDeclineState(hardDecline);
                        return uw.value;
                    }
                    else if (!mtaHardDecline) {
                        _this.setHardDeclineState(hardDecline);
                        return uw.value;
                    }
                }
            }
            return "";
        };
        _this.goBack = _this.goBack.bind(_this);
        _this.state = {
            isHardDecline: false,
            declineMessage: ""
        };
        return _this;
    }
    WolfMTADeclineTextOutputWidget.prototype.render = function () {
        var feeWording = this.chargeCancellationFee(this.props.interaction) ? "" : " without a cancellation fee";
        return ((0, jsx_runtime_1.jsxs)("div", { className: "text-group declineTextWidget", children: [(0, jsx_runtime_1.jsx)("div", { className: "panel", children: this.state.isHardDecline ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("h1", { className: "text-blue-1", children: "Your car policy will be cancelled" }), (0, jsx_runtime_1.jsxs)("div", { className: "font-weight-light pb-4", children: ["Thanks for telling us about your change in circumstances. Unfortunately, we don\u2019t offer this type of cover, so your policy won\u2019t start ", (0, commonFunctions_1.getHardDeclineEndDateText)(this.props.interaction), " 00:00."] }), (0, jsx_runtime_1.jsx)("div", { className: "font-weight-light pb-4", children: "This means no cover will be provided, and we\u2019ll cancel the policy." }), (0, jsx_runtime_1.jsxs)("div", { className: "font-weight-light pb-4", children: ["To help you find the cover you need, give our friends at Gallagher a call on ", (0, jsx_runtime_1.jsx)("b", { children: (0, jsx_runtime_1.jsx)("a", { className: "text-decoration-underline text-blue-1", href: "tel:+44 333 188 7823", "aria-label": "Phone number +44 333 188 7823", children: "0333 188 7823" }) }), " or visit ", (0, jsx_runtime_1.jsx)("b", { children: (0, jsx_runtime_1.jsx)("a", { className: "text-decoration-underline text-blue-1", href: "https://www.biba.org.uk/find-insurance/", target: "_blank", children: "BIBA.org.uk" }) }), ' ', "to look for another suitable provider."] })] })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("h1", { className: "text-center text-blue-1", children: this.state.declineMessage }), (0, jsx_runtime_1.jsx)("div", { className: "text-center font-weight-semi-bold", children: "With the changes you are looking to make, we\u2019d no longer be able to insure you due to the change in risk." }), (0, jsx_runtime_1.jsxs)("div", { className: "text-center font-weight-semi-bold", children: ["You can cancel these changes which will allow the policy to continue, or if the cover is no longer suitable for your needs you can cancel the insurance", feeWording, "."] })] })) }), (0, jsx_runtime_1.jsxs)("div", { children: [this.renderCancelPolicyButton(), (!this.state.isHardDecline) && this.renderCancelChangesButton()] })] }));
    };
    WolfMTADeclineTextOutputWidget.prototype.componentDidMount = function () {
        this.generateText();
    };
    WolfMTADeclineTextOutputWidget.prototype.renderCancelPolicyButton = function () {
        return ((0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: this.state.isHardDecline
                ? "/journey/init/product/AnnualMotorInsurance/process/mtcForced/presetPage/".concat(this.props.interaction._id)
                : "/journey/init/product/AnnualMotorInsurance/process/mtc/presetPage/".concat(this.props.interaction._id), id: "cancelPolicy", className: this.state.isHardDecline ? "hard-decline-link-wrapper" : "", children: (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-primary btn-next decline-cancel ".concat(this.state.isHardDecline ? " hard-decline" : ""), children: "Cancel policy" }) }));
    };
    WolfMTADeclineTextOutputWidget.prototype.renderCancelChangesButton = function () {
        return ((0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "/dashboard", id: "decline-page-back", children: (0, jsx_runtime_1.jsx)("button", { type: "button", role: "link", className: "btn btn-back", children: "Cancel changes" }) }));
    };
    WolfMTADeclineTextOutputWidget.prototype.goBack = function () {
        var interaction = this.props.engine.getInteraction();
        if (interaction.uistate) {
            this.props.onStateChange("uistate.specificUwRuleTriggered", false);
        }
        var journeyState = this.props.engine.getJourneyState();
        var declineReferrerPage = journeyState.declineReferrerPage;
        if (declineReferrerPage === "quoteSummary") {
            declineReferrerPage = "quote";
        }
        this.props.engine.setJourneyState({
            declineReferrerPage: undefined,
        });
        if (declineReferrerPage) {
            this.props.engine.navigate(declineReferrerPage, false);
        }
    };
    WolfMTADeclineTextOutputWidget.prototype.setHardDeclineState = function (hardDecline) {
        this.setState({
            isHardDecline: hardDecline
        });
        this.props.onStateChange("uistate.isHardDecline", hardDecline);
    };
    WolfMTADeclineTextOutputWidget.prototype.chargeCancellationFee = function (interaction) {
        if (interaction.underwritingResult && interaction.underwritingResult.length > 0) {
            var limitFailures = interaction.underwritingResult.find(function (uw) { return uw.objectName === "UWW060" || uw.objectName === "UWW061" || uw.objectName === "UWW062" || uw.objectName === "UWW063"; });
            return limitFailures;
        }
        return false;
    };
    __decorate([
        (0, core_1.lazyInject)(plugin_journey_1.Types.JourneyRuntimeService),
        __metadata("design:type", Object)
    ], WolfMTADeclineTextOutputWidget.prototype, "journeyRuntimeService", void 0);
    return WolfMTADeclineTextOutputWidget;
}(plugin_journey_1.WidgetBase));
exports.WolfMTADeclineTextOutputWidget = WolfMTADeclineTextOutputWidget;
//# sourceMappingURL=WolfMTADeclineTextOutputWidget.js.map